var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ btn: true, grey: _vm.disabled },attrs:{"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('span',{class:{ fa: true, 'fa-chevron-down': !_vm.active, 'fa-chevron-up': _vm.active }})])}
var staticRenderFns = []

export { render, staticRenderFns }